import {
    mapGetters,
    mapMutations,
} from 'vuex';

export default {
    name: 'WarningModal',
    props: {},
    data: () => ({
        isOpen: true,
    }),
    computed: {
        ...mapGetters('appointment', {
            modalTpp: 'getModalTpp',
        }),
    },
    methods: {
        ...mapMutations('appointment', {
            setModalTpp: 'SET_MODALTPP',
        }),
        toggle() {
            this.setModalTpp(false);
        },
    },
};
